import { render, staticRenderFns } from "./Spal.vue?vue&type=template&id=4fbbf467"
import script from "./Spal.vue?vue&type=script&lang=js"
export * from "./Spal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports